import React from 'react';
import { FadeIn } from '../FadeIn';
import { ArrowRight, Headphones, FileText } from 'lucide-react';
export function HeroAHA() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-ivory overflow-hidden" data-id="element-147">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-148">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/10 rounded-full blur-3xl" data-id="element-149"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-forest/5 rounded-full blur-3xl" data-id="element-150"></div>

        {/* Large background text */}
        <div className="absolute top-10 left-0 text-[25vw] font-serif font-bold text-forest/[0.03] whitespace-nowrap select-none leading-none tracking-widest" data-id="element-151">
          A.H.A.
        </div>

        {/* Graphic lines and dots */}
        <div className="absolute top-40 left-10 w-px h-32 bg-gradient-to-b from-gold/40 to-transparent" data-id="element-152"></div>
        <div className="absolute bottom-20 right-20 w-32 h-px bg-gradient-to-r from-forest/20 to-transparent" data-id="element-153"></div>
        <div className="absolute top-1/3 left-1/4 w-1.5 h-1.5 bg-gold/40 rounded-full" data-id="element-154"></div>
        <div className="absolute bottom-1/3 right-1/4 w-2 h-2 bg-forest/20 rounded-full" data-id="element-155"></div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-156">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-157">
          {/* Left - Text fully centered */}
          <div className="flex flex-col items-center text-center order-2 lg:order-1" data-id="element-158">
            <FadeIn data-id="element-159">
              <div className="inline-block border border-gold/40 rounded-full px-5 py-2 mb-6 bg-white/50 backdrop-blur-sm" data-id="element-160">
                <span className="font-display text-sm font-medium tracking-wider text-forest uppercase" data-id="element-161">
                  Anima Healing Academy — AHA
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-162">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-forest mb-6 leading-tight" data-id="element-163">
                Cum îți gestionezi emoțiile copleșitoare
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-164">
              <p className="text-xl md:text-2xl font-serif italic text-charcoal/80 mb-6 max-w-[520px]" data-id="element-165">
                Pentru că a simți nu înseamnă a te pierde
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-166">
              <p className="text-[19px] text-charcoal/70 mb-10 max-w-[540px] leading-relaxed" data-id="element-167">
                Un mini-curs cu 5 audio-uri ghidate și un workbook PDF care te
                învață să îți reglezi emoțiile, pas cu pas, în mai puțin de o
                săptămână.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-168">
              <a href="#checkout" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-forest text-ivory font-display text-lg font-medium hover:bg-forest-light transition-colors no-underline gap-3 group shadow-lg shadow-forest/20" data-id="element-169">
                Intru în curs acum
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-170" />
              </a>
            </FadeIn>

            <FadeIn delay={0.5} data-id="element-171">
              <div className="flex flex-wrap gap-5 mt-8 justify-center" data-id="element-172">
                <div className="flex items-center gap-2 text-charcoal/70" data-id="element-173">
                  <Headphones className="w-5 h-5 text-gold-dark" data-id="element-174" />
                  <span className="text-[15px]" data-id="element-175">5 audio-uri ghidate</span>
                </div>
                <div className="flex items-center gap-2 text-charcoal/70" data-id="element-176">
                  <FileText className="w-5 h-5 text-gold-dark" data-id="element-177" />
                  <span className="text-[15px]" data-id="element-178">Workbook PDF 13 pagini</span>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right - Visual: Audio waves + photo */}
          <div className="order-1 lg:order-2 relative" data-id="element-179">
            <FadeIn direction="right" data-id="element-180">
              <div className="relative max-w-[480px] mx-auto" data-id="element-181">
                {/* Offset decorative frames */}
                <div className="absolute -top-5 -left-5 w-full h-full rounded-[24px] border-2 border-forest/30 -z-10" data-id="element-182"></div>
                <div className="absolute -bottom-5 -right-5 w-full h-full rounded-[24px] bg-gold/20 -z-20" data-id="element-183"></div>

                {/* Floating circles */}
                <div className="absolute -top-10 -right-10 w-24 h-24 border border-gold/50 rounded-full -z-10" data-id="element-184"></div>
                <div className="absolute top-1/4 -left-12 w-16 h-16 bg-forest/10 rounded-full blur-md -z-10" data-id="element-185"></div>

                {/* Botanical SVG */}
                <svg className="absolute -top-8 -right-2 w-20 h-20 text-forest/40 -z-10" viewBox="0 0 100 100" fill="none" data-id="element-186">
                  <path d="M50 10 Q 70 30, 60 50 Q 50 70, 30 60 Q 50 50, 50 10" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15" data-id="element-187" />
                  <path d="M50 10 L 50 60" stroke="currentColor" strokeWidth="1" data-id="element-188" />
                </svg>

                {/* Main card with photo */}
                <div className="rounded-[24px] overflow-hidden border-4 border-white shadow-2xl relative aspect-square bg-forest" data-id="element-189">
                  <img src="https://cdn.magicpatterns.com/uploads/dYL8ug2WVehxcBRNKcSBha/anima_healing_academy_square.jpg" alt="ANIMA Healing Academy - Cum îți gestionezi emoțiile copleșitoare" className="w-full h-full object-cover" data-id="element-190" />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest/40 via-transparent to-transparent pointer-events-none" data-id="element-191"></div>

                  {/* Audio wave overlay at bottom */}
                  <div className="absolute bottom-0 left-0 right-0 p-5 flex flex-col gap-3" data-id="element-192">
                    <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 border border-gold/30 shadow-lg" data-id="element-193">
                      <div className="flex items-center gap-3" data-id="element-194">
                        <div className="w-10 h-10 rounded-full bg-forest flex items-center justify-center shrink-0" data-id="element-195">
                          <Headphones className="w-5 h-5 text-ivory" data-id="element-196" />
                        </div>
                        <div className="flex-1" data-id="element-197">
                          <p className="font-display text-xs text-forest font-semibold tracking-wider uppercase mb-1" data-id="element-198">
                            Audio ghidat
                          </p>
                          {/* Audio waveform */}
                          <div className="flex items-center gap-1 h-6" data-id="element-199">
                            {[3, 5, 7, 4, 8, 6, 9, 5, 7, 4, 6, 8, 5, 3, 7, 5, 4, 6, 8, 5].map((h, i) => <div key={i} className="w-1 bg-gradient-to-t from-gold to-forest rounded-full" style={{
                            height: `${h * 3}px`
                          }} data-id="element-200" />)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating badge */}
                <div className="absolute -bottom-6 -left-4 md:-left-10 bg-white rounded-2xl px-5 py-3 shadow-xl border border-gold/30 z-10" data-id="element-201">
                  <p className="font-serif italic text-forest text-[15px] leading-snug" data-id="element-202">
                    „A simți nu înseamnă a te pierde.”
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}